import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor(  
    private titleService: Title,  
    private metaTagService: Meta  
  ) { }  
    

  ngOnInit() {  
    this.titleService.setTitle("About Avitrons | Crafting Digital Excellence for USA Businesses");  
    
    this.metaTagService.addTags([  
      { name: 'description', content: 'Discover Avitrons commitment to delivering digital excellence to businesses in the USA. Learn about our journey and how we can help your brand thrive in the competitive American market.' },  
      { name: 'robots', content: 'index, follow' },  
      { charset: 'UTF-8' } , 
    ]);  
        
  }  
}  